import { useTranslation } from 'react-i18next';
export function useAnnouncementsTranslation() {
    return useTranslation('announcements');
}
